import classNames from 'classnames'
import classes from './ImageWithOverlay.module.scss'
import PropTypes from 'prop-types'
import ReactPlayer from 'react-player'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import EventCard from '../common/dual-panel-selector/items/EventCard'
import { ReactComponent as PlayIcon } from '../../assets/images/common/icons/play-video-icon.svg'
import StudentCard from '../common/dual-panel-selector/items/StudentCard'
import CoachCard from '../common/dual-panel-selector/items/CoachCard'

const ImageWithOverlay = ({ src, alt, height, viewMore, video, activity, imgStyle, thumbnail }) => {
  const { t } = useTranslation()
  const [display, setDisplay] = useState('media')
  const imgHeight = `calc(${height} - 2.5rem)`

  const series = Array.isArray(activity?.series) ? activity.series : []
  const courses = Array.isArray(activity?.courses) ? activity.courses : []
  const users = activity?.users || []

  const placeHolder = () => (
    <div style={{ height: imgHeight }} className={classes.placeHolder}>
      <i className='fa fa-picture-o'/>
      <h2>{t('activity.imageOverlay.noMediaToShow')}</h2>
    </div>
  )

  const renderMore = () => {
    const students = users.filter((u) => u.type === 'Student')
    const coaches = users.filter((u) => u.type === 'Coach')

    const totalRecipients =
    courses.reduce((acc, p) => acc + (p.students?.length || 0), 0) +
    series.reduce((acc, s) => acc + (s.students?.length || 0), 0) +
    (students.length || 0) +
    (coaches.length || 0)

    return (
      <div style={{ height: imgHeight }} className={classes.eventsContainer}>
        <span className={classes.title}>{t('activity.imageOverlay.totalRecipients', { count: totalRecipients })}</span>
        {series.length > 0 && (
          <>
            <span className={classes.title}>{t('activity.imageOverlay.seriesCount', { count: series.length })}</span>
            {series.map((event) => (
              <EventCard key={event.id} item={event} />
            ))}
          </>
        )}
        {courses.length > 0 && (
          <>
            <span className={classes.title}>{t('activity.imageOverlay.programsCount', { count: courses.length })}</span>
            {courses.map((event) => (
              <EventCard key={event.id} item={event} />
            ))}
          </>
        )}
        {students.length > 0 && (
          <>
            <span className={classes.title}>{t('activity.imageOverlay.studentsCount', { count: students.length })}</span>
            {students.map((student) => (
              <StudentCard key={student.id} item={student} />
            ))}
          </>
        )}
        {coaches.length > 0 && (
          <>
            <span className={classes.title}>{t('activity.imageOverlay.coachesCount', { count: coaches.length })}</span>
            {coaches.map((coach) => (
              <CoachCard key={coach.id} item={coach} />
            ))}
          </>
        )}
      </div>
    )
  }

  const renderMedia = () => {
    if (video) {
      return <div className={classNames({ [classes.playerWrapper]: thumbnail })}>
        <div className={classNames({ [classes.playerOpacity]: thumbnail })}>
          <ReactPlayer url={video} height= {imgHeight} width={'100%'} controls={!thumbnail}/>
        </div>
        {thumbnail && <div className={classes.playIconOverlay}><PlayIcon /></div>}
      </div>

    } else if (src) {
      return <img src={src} alt={alt} className={classes.image} style={{ height: imgHeight, objectFit: imgStyle }}/>
    } else {
      return placeHolder()
    }
  }

  return <div className={classes.imageContainer} style={{ height }}>
    {display === 'media' ? renderMedia() : renderMore()}
    <div className={classes.overlay}>
      <span className={classes.overlay_text}>{alt}</span>
      {viewMore && <button className={classNames(classes.viewMore)}
        onClick={() => setDisplay((prev) => prev === 'media' ? 'more' : 'media')}>
        {display === 'media' ? t('activity.common.viewMore') : t('activity.imageOverlay.viewMedia')}</button>}
    </div>
  </div>
}

ImageWithOverlay.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  viewMore: PropTypes.func,
  video: PropTypes.string,
  activity: PropTypes.object,
  imgStyle: PropTypes.string,
  thumbnail: PropTypes.bool,
}

export default ImageWithOverlay
